import React from "react";
import { useTranslation } from "react-i18next";
import { SystemsMessage } from "./SystemsMessage.jsx";

export const UserRemovedConversationMessage = ({ ...props }) => {
  const { t } = useTranslation();

  return (
    <SystemsMessage
      {...props}
      messageText={t("left conversation")}
    />
  );
};
